import {
  WiseOwlEventEnumType,
  WiseOwlEventEnum,
} from '@twiliointernal/e2-commons-shared-definitions';

const LOG_PREFIX = '[WiseOwlView]';
const WISE_OWL_UNGATED_CHAT_HEIGHT = '69vh';
const WISE_OWL_GATED_CHAT_HEIGHT = '88vh';
const SURVEY_ID = 'SV_0H8qU82qFh47298';
const WISE_OWL_CHAT_MIN_HEIGHT = '750px';

const errorLogMessageToEventTypeMap: Record<WiseOwlEventEnumType, string> = {
  [WiseOwlEventEnum.getChat]: `${LOG_PREFIX}::Error fetching chat`,
  [WiseOwlEventEnum.getChatSummary]: `${LOG_PREFIX}::Chat summary failed`,
  [WiseOwlEventEnum.getSurveyResponsesForLiveChat]: `${LOG_PREFIX}::Get Survey responses for Live Chat failed`,
  [WiseOwlEventEnum.liveChatTransfer]: `${LOG_PREFIX}::Live chat engagement failed`,
  [WiseOwlEventEnum.loginRedirect]: `${LOG_PREFIX}::Login redirect failed`,
  [WiseOwlEventEnum.phoneSupport]: `${LOG_PREFIX}::Phone support engagement failed`,
  [WiseOwlEventEnum.redirect]: `${LOG_PREFIX}::Redirect failed`,
  [WiseOwlEventEnum.sendChatMessage]: `${LOG_PREFIX}::Message send failed`,
  [WiseOwlEventEnum.sendChatMessageRetry]: `${LOG_PREFIX}::`,
  [WiseOwlEventEnum.startNewChat]: `${LOG_PREFIX}::Chat creation failed`,
  [WiseOwlEventEnum.startNewChatRetry]: `${LOG_PREFIX}::Retry start new chat failed`,
  [WiseOwlEventEnum.streamComplete]: `${LOG_PREFIX}::Document stream completion failed`,
  [WiseOwlEventEnum.streamError]: `${LOG_PREFIX}::Document stream failed`,
  [WiseOwlEventEnum.streamInitialize]: `${LOG_PREFIX}::Document steam initialization failed`,
  [WiseOwlEventEnum.submitFeedback]: `${LOG_PREFIX}::Create feedback failed`,
  [WiseOwlEventEnum.submitTicket]: `${LOG_PREFIX}::Ticket submission engagement failed`,
};

const logMessageToEventTypeMap: Record<WiseOwlEventEnumType, string> = {
  [WiseOwlEventEnum.getChat]: `${LOG_PREFIX}::Fetched chat`,
  [WiseOwlEventEnum.getChatSummary]: `${LOG_PREFIX}::Getting Wise Owl chat summary`,
  [WiseOwlEventEnum.getSurveyResponsesForLiveChat]: `${LOG_PREFIX}::Getting Survey responses for Live Chat`,
  [WiseOwlEventEnum.sendChatMessage]: `${LOG_PREFIX}::Updating Wise Owl chat`,
  [WiseOwlEventEnum.sendChatMessageRetry]: `${LOG_PREFIX}::Retry send chat message`,
  [WiseOwlEventEnum.startNewChat]: `${LOG_PREFIX}::Creating Wise Owl chat`,
  [WiseOwlEventEnum.startNewChatRetry]: `${LOG_PREFIX}::Retry start new chat `,
  [WiseOwlEventEnum.streamComplete]: `${LOG_PREFIX}::Document sync completed`,
  [WiseOwlEventEnum.streamInitialize]: `${LOG_PREFIX}::Document sync initialized`,
  [WiseOwlEventEnum.submitFeedback]: `${LOG_PREFIX}::Creating message feedback`,
};

export {
  WISE_OWL_GATED_CHAT_HEIGHT,
  WISE_OWL_UNGATED_CHAT_HEIGHT,
  SURVEY_ID,
  WISE_OWL_CHAT_MIN_HEIGHT,
  LOG_PREFIX,
  errorLogMessageToEventTypeMap,
  logMessageToEventTypeMap,
};
